import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { getPriorityCountries, getOtherCountries } from "@/utils/countries";

const CountrySelect = ({ value, onChange, placeholder = "Seleccionar país", className = "" }) => {
  const priorityCountries = getPriorityCountries();
  const otherCountries = getOtherCountries();

  const getSelectedFlag = () => {
    if (!value) return null;
    const found = [...priorityCountries, ...otherCountries].find(c => c.name === value);
    return found ? found.flag : null;
  };

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder}>
          {value && (
            <span className="flex items-center gap-2">
              <span>{getSelectedFlag()}</span>
              <span>{value}</span>
            </span>
          )}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="max-h-[300px]">
        {/* Priority countries */}
        {priorityCountries.map((c) => (
          <SelectItem key={c.name} value={c.name}>
            <span className="flex items-center gap-2">
              <span>{c.flag}</span>
              <span>{c.name}</span>
            </span>
          </SelectItem>
        ))}
        {/* Separator */}
        <SelectItem value="---separator---" disabled>
          <span className="text-slate-300">──────────────</span>
        </SelectItem>
        {/* Other countries */}
        {otherCountries.map((c) => (
          <SelectItem key={c.name} value={c.name}>
            <span className="flex items-center gap-2">
              <span>{c.flag}</span>
              <span>{c.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CountrySelect;
